import { Badge } from '@codes/ui-kit';

interface SectionHeaderProps {
    title: string;
    description?: string;
    badge?: string;
}

export const SectionHeader = ({ title, description, badge }: SectionHeaderProps) => (
    <div className="flex items-center gap-3 mb-4">
        <div className="flex-1">
            <h2 className="text-base md:text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
            {description && <p className="text-xs md:text-sm text-gray-600 dark:text-gray-400 mt-1">{description}</p>}
        </div>
        {badge && (
            <Badge variant="secondary" className="text-xs">
                {badge}
            </Badge>
        )}
    </div>
);
